module.exports = __webpack_public_path__ + "front/img/bg-success.0cb6b527.png";